import type * as Types from '../../../__generated__/globalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CustomerTosStatusQuery_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Query_getTOSStatus_OdProtosCustomerTosV1Data_CustomerTOSStatus = {
  __typename: 'OdProtosCustomerTosV1Data_CustomerTOSStatus',
  updateRequired: boolean
};

export type CustomerTosStatusQuery_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Query = {
  __typename: 'OdProtosCustomerTosV1Services_CustomerTOS_Query',
  getTOSStatus: CustomerTosStatusQuery_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Query_getTOSStatus_OdProtosCustomerTosV1Data_CustomerTOSStatus | null
};

export type CustomerTosStatusQuery_Query = {
  customerTos: CustomerTosStatusQuery_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Query
};


export type CustomerTosStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerTosStatusQuery = CustomerTosStatusQuery_Query;

export type SetCustomerTosAcceptedMutation_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Mutation_tOSAccepted_OdProtosCustomerTosV1Services_Responses_TOSAccepted = {
  __typename: 'OdProtosCustomerTosV1Services_Responses_TOSAccepted',
  _empty: boolean | null
};

export type SetCustomerTosAcceptedMutation_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Mutation = {
  __typename: 'OdProtosCustomerTosV1Services_CustomerTOS_Mutation',
  tOSAccepted: SetCustomerTosAcceptedMutation_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Mutation_tOSAccepted_OdProtosCustomerTosV1Services_Responses_TOSAccepted | null
};

export type SetCustomerTosAcceptedMutation_Mutation = {
  customerTos: SetCustomerTosAcceptedMutation_customerTos_OdProtosCustomerTosV1Services_CustomerTOS_Mutation
};


export type SetCustomerTosAcceptedMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SetCustomerTosAcceptedMutation = SetCustomerTosAcceptedMutation_Mutation;


export const CustomerTosStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerTOSStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTOSStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRequired"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerTosStatusQuery, CustomerTosStatusQueryVariables>;
export const SetCustomerTosAcceptedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCustomerTOSAccepted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tOSAccepted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}}]}}]}}]} as unknown as DocumentNode<SetCustomerTosAcceptedMutation, SetCustomerTosAcceptedMutationVariables>;